export const objectToQueryString = (params) => {
    let query = '';
    let iteration = 0;
    Object.keys(params).forEach(key => {
        const value = params[key];
        if (value === undefined || value === null || value === '') {
            return;
        }
        const separator = iteration === 0 ? '?' : '&';
        query = `${query}${separator}${key}=${encodeURIComponent(`${value}`)}`;
        iteration++;
    });
    return query;
};
